<form novalidate (submit)="$event.preventDefault(); addPrice()">
  <div class="row mb-2">
    <div class="col-12">
      <div class="row">
        <div class="col-12 col-md-5">
          <input
            #bundleTypeaheadElement
            #instance="ngbTypeahead"
            type="text"
            class="form-control mb-2"
            container="body"
            data-cy="country-bundle-typeahead"
            [placeholder]="
              'pricing.country.details.placeholders.bundle' | translate
            "
            [resultTemplate]="itemTemplate"
            [inputFormatter]="inputFormatter"
            [ngbTypeahead]="search"
            (selectItem)="setBundle($event.item)"
            (focus)="focus$.next($event.target.value)"
            (click)="click$.next($event.target.value)"
          />

          <ng-template #itemTemplate let-r="result" let-t="term">
            <ngb-highlight [result]="r.internalName" [term]="t"></ngb-highlight>
          </ng-template>
        </div>
        <div class="col-4 col-md-2">
          <app-select
            class="d-block"
            data-cy="country-price-type-select"
            [selected]="priceModel().type"
            (changed)="setType($event)"
          >
            @for (priceType of priceTypes; track priceType) {
              <app-select-option
                [label]="'pricing.country.priceTypes.' + priceType | translate"
                [value]="priceType"
              />
            }
          </app-select>
        </div>
        <div class="col-4 col-md-2">
          <input
            #validFromDatepicker="ngbDatepicker"
            ngbDatepicker
            class="form-control"
            id="countryValidFrom"
            container="body"
            data-cy="country-valid-from-input"
            [formField]="priceForm.validFrom"
            [readonly]="true"
            [minDate]="momentToNgbDate(minDate)"
            [maxDate]="momentToNgbDate(maxDate)"
            [startDate]="momentToNgbDate(startDate)"
            [placeholder]="
              'serviceData.form.placeholders.dateFormat' | translate
            "
            (click)="validFromDatepicker.toggle()"
          />
        </div>
        <div class="col-3 col-md-2">
          <input
            type="number"
            step="any"
            class="form-control"
            data-cy="country-price-input"
            [formField]="priceForm.price"
            [placeholder]="
              'pricing.country.details.placeholders.price' | translate
            "
          />
        </div>
        <div class="col-1 col-md-1">
          <button
            type="submit"
            class="icon-btn icon-btn-lg"
            triggers="hover"
            placement="top"
            data-cy="add-country-price-btn"
            [ngbTooltip]="'pricing.country.details.addPriceTooltip' | translate"
            [disabled]="!canSubmit()"
          >
            <i class="fa-light fa-plus"></i>
          </button>
        </div>
      </div>
      @if (priceForm.price().touched() && priceForm.price().invalid()) {
        <div class="row">
          <div class="offset-8 offset-md-9 col-3 col-md-2">
            @for (error of priceForm.price().errors(); track error.kind) {
              <small class="text-danger">
                {{ 'validation.generic.' + error.kind | translate }}
              </small>
            }
          </div>
        </div>
      }
      @if (firstTimePrice()) {
        <div class="row">
          <div class="col-12 my-2">
            <div class="notes">
              {{ 'pricing.country.details.priceWarning' | translate }}
            </div>
          </div>
        </div>
      }
      @if (noCurrencyWarning()) {
        <div class="row">
          <div class="col-12 my-2">
            <div class="notes">
              {{ 'pricing.country.details.noCurrencyWarning' | translate }}
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</form>
